import React from "react";
import WaveText from "../WaveText";

export default function ErrorCorrectionGeneratorPanel({
  showErrorCorrectionGenerator, generatedErrorCorrection, showAskMe, showTemplates,
  showWordDefinitionGenerator, showWordTranslationGenerator, showTrueFalseGenerator,
  showWarmUpDiscussionGenerator, showCreateDialogueGenerator, showEssentialVocabularyGenerator,
  showLeadInActivitiesGenerator, showFourOpinionsGenerator, showCommunicativeSituationsGenerator,
  showMatchingHalvesGenerator, showGrammarRulesGenerator,
  errorCorrectionInput, setErrorCorrectionInput, errorCorrectionLevel, setErrorCorrectionLevel,
  errorCorrectionSentenceCount, setErrorCorrectionSentenceCount, errorCorrectionLoading,
  handleErrorCorrectionGenerate, handleErrorCorrectionInsert, handleErrorCorrectionCancel,
}) {
  if (!((showErrorCorrectionGenerator || generatedErrorCorrection) && !showAskMe && !showTemplates && !showWordDefinitionGenerator && !showWordTranslationGenerator && !showTrueFalseGenerator && !showWarmUpDiscussionGenerator && !showCreateDialogueGenerator && !showEssentialVocabularyGenerator && !showLeadInActivitiesGenerator && !showFourOpinionsGenerator && !showCommunicativeSituationsGenerator && !showMatchingHalvesGenerator && !showGrammarRulesGenerator)) {
    return null;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, transition: 'opacity 0.22s, transform 0.22s' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button onClick={handleErrorCorrectionCancel} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: 4, transition: 'color 0.18s' }}>
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none"><path d="M12 16l-4-4 4-4" stroke="#8a2be2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
        <span style={{ fontSize: 16, fontWeight: 600, color: '#22223b' }}>Generate Error Correction</span>
      </div>

      <textarea
        value={errorCorrectionInput}
        onChange={e => setErrorCorrectionInput(e.target.value)}
        placeholder="Describe the grammatical structure or vocabulary you want to practice (e.g., past tense, articles, conditionals, vacation vocabulary, work experiences)..."
        rows={4}
        style={{
          fontSize: 15,
          padding: '12px',
          borderRadius: 8,
          border: '1.5px solid #cfcfff',
          background: '#f7fbff',
          resize: 'vertical',
          fontFamily: 'Inter, Segoe UI, Arial, sans-serif',
          width: '100%',
          boxSizing: 'border-box'
        }}
      />

      <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
          CEFR Level:
          <select
            value={errorCorrectionLevel}
            onChange={e => setErrorCorrectionLevel(e.target.value)}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              cursor: 'pointer'
            }}
          >
            <option value="A1">A1 - Beginner</option>
            <option value="A2">A2 - Elementary</option>
            <option value="B1">B1 - Intermediate</option>
            <option value="B2">B2 - Upper Intermediate</option>
            <option value="C1">C1 - Advanced</option>
            <option value="C2">C2 - Mastery</option>
          </select>
        </label>
        <label style={{ fontSize: 14, fontWeight: 500, color: '#22223b', display: 'flex', alignItems: 'center', gap: 8 }}>
          Sentences:
          <select
            value={errorCorrectionSentenceCount}
            onChange={e => setErrorCorrectionSentenceCount(parseInt(e.target.value))}
            style={{
              fontSize: 14,
              padding: '6px 8px',
              borderRadius: 6,
              border: '1.5px solid #cfcfff',
              background: '#fff',
              cursor: 'pointer'
            }}
          >
            <option value={3}>3</option>
            <option value={5}>5</option>
            <option value={7}>7</option>
            <option value={10}>10</option>
          </select>
        </label>
      </div>

      <button
        onClick={handleErrorCorrectionGenerate}
        disabled={errorCorrectionLoading || !errorCorrectionInput.trim()}
        className={errorCorrectionLoading ? 'magic-generating-btn' : 'magic-btn'}
        style={{
          fontSize: 15,
          padding: '12px 16px',
          borderRadius: 8,
          border: 'none',
          background: errorCorrectionLoading || !errorCorrectionInput.trim() ? '#e0e0e0' : '#8a2be2',
          color: errorCorrectionLoading || !errorCorrectionInput.trim() ? '#999' : '#fff',
          fontWeight: 600,
          cursor: errorCorrectionLoading || !errorCorrectionInput.trim() ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s'
        }}
      >
        {errorCorrectionLoading ? <WaveText /> : 'Do the magic'}
      </button>

      {generatedErrorCorrection && (
        <div style={{ marginTop: 12, padding: 12, background: '#f8f9fa', borderRadius: 8, border: '1px solid #e9ecef' }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: '#22223b', marginBottom: 8 }}>
            Generated: Error Correction Exercise
          </div>
          <div style={{ fontSize: 13, color: '#6c757d', marginBottom: 12 }}>
            {generatedErrorCorrection.sentences.length} sentences ready
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button
              onClick={handleErrorCorrectionInsert}
              className="magic-btn"
              style={{ fontSize: 14, padding: '8px 16px', borderRadius: 6, fontWeight: 600, cursor: 'pointer', width: '100%' }}
            >
              Add
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
